import React from "react";
import moment from "moment";
import CierreCentralizadoUI from "./CierreCentralizadoUI";

class CierreCajaCentralizado extends React.Component {
    constructor(props) {
        super(props);
        
        const fechaActual = this.formatMomentForInput(moment());
        const fechaMinima = this.formatMomentForInput(moment().subtract(7, 'days'));
        
        this.state = {
            cajas: [],
            columns: [],
            isLoading: false,
            fechaInicio: fechaActual,
            fechaFin: fechaActual,
            fechaMinima: fechaMinima,
            fechaMaxima: fechaActual,
            idSucursal: "",
            sucursales: [],
            cajaSeleccionada: null, // Para mostrar detalles de una caja específica
            showHelp: false,
        }

        this.formatAmount = this.formatAmount.bind(this);
    }

    formatAmount = (amount) => {
        let monto = parseFloat(amount);
        if (isNaN(monto)) {
            monto = 0;
        }

        const formattedMonto = monto.toLocaleString("en", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        return `S/ ${formattedMonto}`;
    }
    
    componentDidMount = async () => {
        this.setState({
            isLoading: true
        });

        await this.fetchSucursales();
        await this.fetchTurnos();
    }

    fetchSucursales = async () => {
        try {
            const response = await fetch("/api/sucursales/SucursalEmpresa");
            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
            
            const sucursales = await response.json();
            const primeraSucursal = sucursales.length > 0 ? sucursales[0].IdSucursal : "";
            
            this.setState({
                sucursales: sucursales || [],
                idSucursal: primeraSucursal,
                isLoading: false
            });
            
        } catch (e) {
            console.error("Error fetching sucursales:", e);
            this.setState({
                error: "Error al cargar las sucursales",
                isLoading: false,
                sucursales: []
            });
        }
    }

    fetchTurnos = async () => {
        try {
            this.setState({ isLoading: true, error: null });
            
            let url = `/api/cajas/cajas-por-sucursal?fechaInicio=${this.state.fechaInicio}&fechaFin=${this.state.fechaFin}`;
            
            if (this.state.idSucursal) {
                url += `&idSucursal=${this.state.idSucursal}`;
            }
            
            const req = await fetch(url);
            
            if (!req.ok) {
                throw new Error(`Error ${req.status}: ${req.statusText}`);
            }
            
            const data = await req.json();
            this.setState({
                cajas: data || [],
                cajaSeleccionada: null, // Resetear caja seleccionada
                isLoading: false
            });
        } catch (error) {
            console.error("Error fetching data:", error);
            this.setState({
                error: "Error al cargar los datos de cierre de caja",
                isLoading: false,
                cajas: []
            });
        }
    }

    // Método para calcular estadísticas generales
    calcularEstadisticasGenerales = () => {
        const { cajas } = this.state;
        
        if (!cajas || cajas.length === 0) {
            return {
                totalEfectivoSistema: 0,
                totalEfectivoUsuario: 0,
                diferenciaEfectivo: 0,
                totalYapeSistema: 0,
                totalYapeUsuario: 0,
                diferenciaYape: 0,
                totalPOSSistema: 0,
                totalPOSUsuario: 0,
                diferenciaPOS: 0,
                totalPlinSistema: 0,
                totalPlinUsuario: 0,
                diferenciaPlin: 0,
                totalOtraTarjetaSistema: 0,
                totalOtraTarjetaUsuario: 0,
                diferenciaOtraTarjeta: 0,
                totalSistema: 0,
                totalUsuario: 0,
                diferenciaTotal: 0
            };
        }

        let estadisticas = {
            totalEfectivoSistema: 0,
            totalEfectivoUsuario: 0,
            totalYapeSistema: 0,
            totalYapeUsuario: 0,
            totalPOSSistema: 0,
            totalPOSUsuario: 0,
            totalPlinSistema: 0,
            totalPlinUsuario: 0,
            totalOtraTarjetaSistema: 0,
            totalOtraTarjetaUsuario: 0,
            totalPedidosYaSistema: 0,
            totalPedidosYaUsuario: 0,
            totalCirkulaSistema: 0,
            totalCirkulaUsuario: 0
        };

        cajas.forEach(caja => {
            estadisticas.totalEfectivoSistema += parseFloat(caja.MontoFinalEfectivoSistema || 0);
            estadisticas.totalEfectivoUsuario += parseFloat(caja.MontoFinalEfectivoFisico || 0);
            estadisticas.totalYapeSistema += parseFloat(caja.MontoFinalYapeSistema || 0);
            estadisticas.totalYapeUsuario += parseFloat(caja.MontoFinalYape || 0);
            estadisticas.totalPOSSistema += parseFloat(caja.MontoFinalTarjetaVisaSistema || 0);
            estadisticas.totalPOSUsuario += parseFloat(caja.MontoFinalTarjetaVisaFisico || 0);
            estadisticas.totalPlinSistema += parseFloat(caja.MontoFinalPlinSistema || 0);
            estadisticas.totalPlinUsuario += parseFloat(caja.MontoFinalPlin || 0);
            estadisticas.totalOtraTarjetaSistema += parseFloat(caja.MontoFinalOtraTarjetaSistema || 0);
            estadisticas.totalOtraTarjetaUsuario += parseFloat(caja.MontoFinalOtraTarjetaFisico || 0);
            estadisticas.totalPedidosYaSistema += parseFloat(caja.MontoFinalTarjetaMasterCardSistema || 0);
            estadisticas.totalPedidosYaUsuario += parseFloat(caja.MontoFinalTarjetaMasterCardFisico || 0);
            estadisticas.totalCirkulaSistema += parseFloat(caja.MontoFinalTarjetaAmericanSistema || 0);
            estadisticas.totalCirkulaUsuario += parseFloat(caja.MontoFinalTarjetaAmericanFisico || 0);
        });

        // Calcular diferencias
        estadisticas.diferenciaEfectivo = estadisticas.totalEfectivoUsuario - estadisticas.totalEfectivoSistema;
        estadisticas.diferenciaYape = estadisticas.totalYapeUsuario - estadisticas.totalYapeSistema;
        estadisticas.diferenciaPOS = estadisticas.totalPOSUsuario - estadisticas.totalPOSSistema;
        estadisticas.diferenciaPlin = estadisticas.totalPlinUsuario - estadisticas.totalPlinSistema;
        estadisticas.diferenciaOtraTarjeta = estadisticas.totalOtraTarjetaUsuario - estadisticas.totalOtraTarjetaSistema;
        estadisticas.diferenciaPedidosYa = estadisticas.totalPedidosYaUsuario - estadisticas.totalPedidosYaSistema;
        estadisticas.diferenciaCirkula = estadisticas.totalCirkulaUsuario - estadisticas.totalCirkulaSistema;

        // Calcular totales generales
        estadisticas.totalSistema = 
            estadisticas.totalEfectivoSistema + 
            estadisticas.totalYapeSistema + 
            estadisticas.totalPOSSistema + 
            estadisticas.totalPlinSistema + 
            estadisticas.totalOtraTarjetaSistema +
            estadisticas.totalPedidosYaSistema +
            estadisticas.totalCirkulaSistema;

        estadisticas.totalUsuario = 
            estadisticas.totalEfectivoUsuario + 
            estadisticas.totalYapeUsuario + 
            estadisticas.totalPOSUsuario + 
            estadisticas.totalPlinUsuario + 
            estadisticas.totalOtraTarjetaUsuario +
            estadisticas.totalPedidosYaUsuario +
            estadisticas.totalCirkulaUsuario;

        estadisticas.diferenciaTotal = estadisticas.totalUsuario - estadisticas.totalSistema;

        return estadisticas;
    }

    // Método para ver detalles de una caja específica
    verDetallesCaja = (caja) => {
        this.setState({
            cajaSeleccionada: caja
        });
    }

    // Método para calcular estadísticas de una caja específica
    calcularEstadisticasCaja = (caja) => {
        if (!caja) return null;
        
        const estadisticas = {
            // Información básica
            nombreCaja: caja.NombreCaja,
            sucursal: caja.NombreSucursal,
            usuario: caja.NombreUsuario,
            supervisor: caja.NombreSupervisor || "Sin supervisor",
            fechaInicio: moment(caja.FechaInicio).format('DD/MM/YYYY HH:mm'),
            fechaCierre: caja.FechaFin ? moment(caja.FechaFin).format('DD/MM/YYYY HH:mm') : "En Curso",
            estado: caja.FechaFin ? "Cerrada" : "Abierta",
            
            // Montos
            montoInicial: parseFloat(caja.MontoInicial || 0),
            
            // Efectivo
            efectivoSistema: parseFloat(caja.MontoFinalEfectivoSistema || 0),
            efectivoUsuario: parseFloat(caja.MontoFinalEfectivoFisico || 0),
            diferenciaEfectivo: 0,
            
            // Yape
            yapeSistema: parseFloat(caja.MontoFinalYapeSistema || 0),
            yapeUsuario: parseFloat(caja.MontoFinalYape || 0),
            diferenciaYape: 0,
            
            // POS
            posSistema: parseFloat(caja.MontoFinalTarjetaVisaSistema || 0),
            posUsuario: parseFloat(caja.MontoFinalTarjetaVisaFisico || 0),
            diferenciaPOS: 0,
            
            // Plin
            plinSistema: parseFloat(caja.MontoFinalPlinSistema || 0),
            plinUsuario: parseFloat(caja.MontoFinalPlin || 0),
            diferenciaPlin: 0,
            
            // Otras tarjetas
            otraTarjetaSistema: parseFloat(caja.MontoFinalOtraTarjetaSistema || 0),
            otraTarjetaUsuario: parseFloat(caja.MontoFinalOtraTarjetaFisico || 0),
            diferenciaOtraTarjeta: 0,

            // Pedidos Ya (MasterCard)
            pedidosYaSistema: parseFloat(caja.MontoFinalTarjetaMasterCardSistema || 0),
            pedidosYaUsuario: parseFloat(caja.MontoFinalTarjetaMasterCardFisico || 0),
            diferenciaPedidosYa: 0,

            // Cirkula (American)
            cirkulaSistema: parseFloat(caja.MontoFinalTarjetaAmericanSistema || 0),
            cirkulaUsuario: parseFloat(caja.MontoFinalTarjetaAmericanFisico || 0),
            diferenciaCirkula: 0,
            
            // Totales
            totalSistema: 0,
            totalUsuario: 0,
            diferenciaTotal: 0,
            
            // Otras estadísticas
            tunki: parseFloat(caja.MontoFinalTunki || 0),
            rappi: parseFloat(caja.MontoFinalRappi || 0),
            fpay: parseFloat(caja.MontoFinalFpay || 0),
            pedidos: parseFloat(caja.MontoFinalPedidos || 0)
        };

        // Calcular diferencias
        estadisticas.diferenciaEfectivo = estadisticas.efectivoUsuario - estadisticas.efectivoSistema;
        estadisticas.diferenciaYape = estadisticas.yapeUsuario - estadisticas.yapeSistema;
        estadisticas.diferenciaPOS = estadisticas.posUsuario - estadisticas.posSistema;
        estadisticas.diferenciaPlin = estadisticas.plinUsuario - estadisticas.plinSistema;
        estadisticas.diferenciaOtraTarjeta = estadisticas.otraTarjetaUsuario - estadisticas.otraTarjetaSistema;
        estadisticas.diferenciaPedidosYa = estadisticas.pedidosYaUsuario - estadisticas.pedidosYaSistema;
        estadisticas.diferenciaCirkula = estadisticas.cirkulaUsuario - estadisticas.cirkulaSistema;

        // Calcular totales
        estadisticas.totalSistema = 
            estadisticas.efectivoSistema + 
            estadisticas.yapeSistema + 
            estadisticas.posSistema + 
            estadisticas.plinSistema + 
            estadisticas.otraTarjetaSistema +
            estadisticas.pedidosYaSistema +
            estadisticas.cirkulaSistema;

        estadisticas.totalUsuario = 
            estadisticas.efectivoUsuario + 
            estadisticas.yapeUsuario + 
            estadisticas.posUsuario + 
            estadisticas.plinUsuario + 
            estadisticas.otraTarjetaUsuario +
            estadisticas.pedidosYaUsuario +
            estadisticas.cirkulaUsuario;

        estadisticas.diferenciaTotal = estadisticas.totalUsuario - estadisticas.totalSistema;

        return estadisticas;
    }

    getResumenPorCaja = () => {
        const { cajas } = this.state;
        
        if (!cajas || cajas.length === 0) return [];

        return cajas.map(caja => {
            const estadisticas = this.calcularEstadisticasCaja(caja);
            return {
                id: caja.IdTurnoCaja,
                nombreCaja: caja.NombreCaja,
                usuario: caja.NombreUsuario,
                estado: caja.FechaFin ? "Cerrada" : "Abierta",
                efectivoSistema: estadisticas.efectivoSistema,
                efectivoUsuario: estadisticas.efectivoUsuario,
                diferenciaEfectivo: estadisticas.diferenciaEfectivo,
                totalSistema: estadisticas.totalSistema,
                totalUsuario: estadisticas.totalUsuario,
                diferenciaTotal: estadisticas.diferenciaTotal,
                rawData: caja
            };
        });
    }

    onChangeSucursal = (e) => {
        const selectedSucursalId = e.target.value;
        this.setState({ 
            idSucursal: selectedSucursalId,
            cajaSeleccionada: null
        }, () => {
            this.fetchTurnos();
        });
    }

    formatMomentForInput = (momentDate) => {
        return momentDate.format("YYYY-MM-DD");
    }

    onChangeFecha = (e) => {
        const { name, value } = e.target;
        
        this.setState(prevState => {
            let newState = { [name]: value };
            
            if (name === 'fechaInicio') {
                if (value > prevState.fechaFin) {
                    newState.fechaFin = value;
                }
            } else if (name === 'fechaFin') {
                if (value < prevState.fechaInicio) {
                    newState.fechaInicio = value;
                }
            }
            
            return newState;
        }, () => {
            clearTimeout(this.fetchTimeout);
            this.fetchTimeout = setTimeout(() => {
                this.fetchTurnos();
            }, 500);
        });
    }
    
    getMaxFechaFin = () => {
        return this.formatMomentForInput(moment());
    }

    getMinFechaInicio = () => {
        return this.formatMomentForInput(moment().subtract(7, 'days'));
    }

    getMaxFechaInicio = () => {
        return this.state.fechaFin;
    }

    getMinFechaFin = () => {
        return this.state.fechaInicio;
    }
    
    sanitizeValue(value, decimals) {
        if (value === null || value === undefined) {
            return "";
        }
        if (typeof value === "number") {
            return typeof decimals === "number" ? value.toFixed(decimals) : value.toString();
        }
        if (typeof value === "string") {
            let num = Number(value);
            if (!isNaN(num) && typeof decimals === "number") {
                return num.toFixed(decimals);
            }
            return value.trim().replace(/[\x00-\x1F\x7F-\x9F]/g, "");
        }
        return String(value);
    }

    getDataCierreExportExcel(dataSet) {
        const dataToExport = Array.isArray(dataSet) ? dataSet : [];
        const estadisticas = this.calcularEstadisticasGenerales();
        
        return [
            {
                columns: [
                    { title: "Caja", width: { wpx: 100 }}, 
                    { title: "Sucursal", width: { wpx: 100 }},
                    { title: "Usuario", width: { wpx: 100 }},
                    { title: "Estado", width: { wpx: 80 }},
                    { title: "FechaInicio", width: { wpx: 150 }},
                    { title: "FechaCierre", width: { wpx: 150 }},
                    { title: "MontoApertura", width: { wpx: 120 }},
                    { title: "Efectivo Sis.", width: { wpx: 120 }},
                    { title: "Efectivo Usuario", width: { wpx: 120 }},
                    { title: "Dif. Efectivo", width: { wpx: 120 }},
                    { title: "Yape Sis.", width: { wpx: 100 }},
                    { title: "Yape Usuario", width: { wpx: 100 }},
                    { title: "Dif. Yape", width: { wpx: 100 }},
                    { title: "Pos Sis.", width: { wpx: 100 }},
                    { title: "Pos Usuario", width: { wpx: 100 }},
                    { title: "Dif. POS", width: { wpx: 100 }},
                    { title: "Plin Sis.", width: { wpx: 100 }},
                    { title: "Plin Usuario", width: { wpx: 100 }},
                    { title: "Dif. Plin", width: { wpx: 100 }},
                    { title: "O. Tarjeta Sis.", width: { wpx: 120 }},
                    { title: "O. Tarjeta Usuario", width: { wpx: 120 }},
                    { title: "Dif. O. Tarjeta", width: { wpx: 120 }},
                    { title: "Pedidos Ya Sis.", width: { wpx: 100 }},
                    { title: "Pedidos Ya Usuario", width: { wpx: 100 }},
                    { title: "Dif. Pedidos Ya", width: { wpx: 100 }},
                    { title: "Cirkula Sis.", width: { wpx: 100 }},
                    { title: "Cirkula Usuario", width: { wpx: 100 }},
                    { title: "Dif. Cirkula", width: { wpx: 100 }},
                    { title: "Total Sistema", width: { wpx: 120 }},
                    { title: "Total Usuario", width: { wpx: 120 }},
                    { title: "Dif. Total", width: { wpx: 120 }},
                ],
                data: dataToExport.map(row => {
                    const estadisticasCaja = this.calcularEstadisticasCaja(row);
                    return [
                        { value: this.sanitizeValue(row.NombreCaja), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.NombreSucursal), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.NombreUsuario), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.FechaFin ? "Cerrada" : "Abierta"), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(moment(row.FechaInicio).format('DD/MM/YYYY HH:mm')), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.FechaFin ? moment(row.FechaFin).format('DD/MM/YYYY HH:mm') : "En Curso"), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoInicial), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalEfectivoSistema), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalEfectivoFisico), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(estadisticasCaja.diferenciaEfectivo, 2), style: { font: { sz: "12", bold: false, color: { rgb: estadisticasCaja.diferenciaEfectivo >= 0 ? "008000" : "FF0000" } }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalYapeSistema), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalYape), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(estadisticasCaja.diferenciaYape, 2), style: { font: { sz: "12", bold: false, color: { rgb: estadisticasCaja.diferenciaYape >= 0 ? "008000" : "FF0000" } }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalTarjetaVisaSistema), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalTarjetaVisaFisico), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(estadisticasCaja.diferenciaPOS, 2), style: { font: { sz: "12", bold: false, color: { rgb: estadisticasCaja.diferenciaPOS >= 0 ? "008000" : "FF0000" } }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalPlinSistema), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalPlin), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(estadisticasCaja.diferenciaPlin, 2), style: { font: { sz: "12", bold: false, color: { rgb: estadisticasCaja.diferenciaPlin >= 0 ? "008000" : "FF0000" } }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalOtraTarjetaSistema), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalOtraTarjetaFisico), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(estadisticasCaja.diferenciaOtraTarjeta, 2), style: { font: { sz: "12", bold: false, color: { rgb: estadisticasCaja.diferenciaOtraTarjeta >= 0 ? "008000" : "FF0000" } }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalTarjetaMasterCardSistema), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalTarjetaMasterCardFisico), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(estadisticasCaja.diferenciaPedidosYa, 2), style: { font: { sz: "12", bold: false, color: { rgb: estadisticasCaja.diferenciaPedidosYa >= 0 ? "008000" : "FF0000" } }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalTarjetaAmericanSistema), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalTarjetaAmericanFisico), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(estadisticasCaja.diferenciaCirkula, 2), style: { font: { sz: "12", bold: false, color: { rgb: estadisticasCaja.diferenciaCirkula >= 0 ? "008000" : "FF0000" } }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(estadisticasCaja.totalSistema, 2), style: { font: { sz: "12", bold: true }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(estadisticasCaja.totalUsuario, 2), style: { font: { sz: "12", bold: true }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(estadisticasCaja.diferenciaTotal, 2), style: { font: { sz: "12", bold: true, color: { rgb: estadisticasCaja.diferenciaTotal >= 0 ? "008000" : "FF0000" } }, alignment: { horizontal: "left" } } },
                    ]
                })
            }
        ]
    }

    render() {
        const { cajas, cajaSeleccionada } = this.state;
        const estadisticasGenerales = this.calcularEstadisticasGenerales();
        const estadisticasCajaSeleccionada = cajaSeleccionada ? this.calcularEstadisticasCaja(cajaSeleccionada) : null;
        const resumenPorCaja = this.getResumenPorCaja();

        let dataExcel = null;
        if (cajas && cajas.length > 0) {
            dataExcel = this.getDataCierreExportExcel(cajas);
        }

        return (
            <CierreCentralizadoUI
                state={this.state}
                estadisticasGenerales={estadisticasGenerales}
                estadisticasCajaSeleccionada={estadisticasCajaSeleccionada}
                resumenPorCaja={resumenPorCaja}
                dataExcel={dataExcel}
                formatAmount={this.formatAmount}
                onChangeFecha={this.onChangeFecha}
                getMinFechaInicio={this.getMinFechaInicio}
                getMaxFechaInicio={this.getMaxFechaInicio}
                getMinFechaFin={this.getMinFechaFin}
                getMaxFechaFin={this.getMaxFechaFin}
                onChangeSucursal={this.onChangeSucursal}
                setShowHelp={(show) => this.setState({ showHelp: show })}
                verDetallesCaja={this.verDetallesCaja}
                clearCajaSeleccionada={() => this.setState({ cajaSeleccionada: null })}
            />
        );
    }
}

export default CierreCajaCentralizado;